<template>
  <div class="hos-table-title">
    <h2>{{ summary.name }}</h2>
  </div>
  <div class="table-responsive">
    <table class="hos-table">
      <thead>
        <tr>
          <th class="text-start">Particulars</th>
          <th class="text-end">Today</th>
          <th class="text-end">Last Day</th>
          <th class="text-end">This Month</th>
          <th class="text-end">This Year</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(list, index) in summary.data" :key="index">
          <tr>
            <td class="text-start">{{ list.name }}</td>
            <td class="text-end">{{ onlyCommaFormat(list.today) }} </td>
            <td class="text-end">{{ onlyCommaFormat(list.yesterday) }}</td>
            <td class="text-end">{{ onlyCommaFormat(list.this_month) }}</td>
            <td class="text-end">{{ onlyCommaFormat(list.this_year) }}</td>
          </tr>
          <tr v-if="index === 3 && summary.type == 'billing'" class="hos-table-divider-row">
            <td colspan="5">
              <hr class="hos-table-divider">
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script setup>
import figureFormatter from "@/services/utils/figureFormatter";

const { onlyCommaFormat } = figureFormatter()

const props = defineProps({
  summary: Object
})
</script>

<style scoped>
.hos-table-title {
  text-align: center;
  margin-bottom: 8px;
}

.hos-table-title h2 {
  font-size: 15px;
  font-weight: 700;
  color: #2b2b2b;
  padding: 4px 0;
  margin: 0;
}

.hos-table {
  width: 100%;
  font-size: 13px;
  border-collapse: collapse;
}

.hos-table thead th {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: #6e6b7b;
  padding: 10px 8px;
  border-bottom: 1px solid #f0f1f4;
}

.hos-table tbody td {
  padding: 9px 8px;
  color: #4a4a4a;
}

.hos-table tbody tr:not(.hos-table-divider-row):hover {
  background-color: #f8f9fa;
}

.hos-table-divider-row td {
  padding: 4px 8px;
}

.hos-table-divider {
  margin: 0;
  border: none;
  border-top: 1px solid #2b2b2b;
  opacity: 0.15;
}
</style>
